import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

export const HomeGalleryData = () => {
  const [GalleryDataUser, setGalleryDataUser] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get("https://admin.gosaviadvanceddentalclinic.com/api/getGalleryData");
      setGalleryDataUser(response.data);
    };

    fetchData();
  }, []);

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`https://admin.gosaviadvanceddentalclinic.com/api/deleteGalleryData/${userId}`);

      setGalleryDataUser((prevUsers) =>
        prevUsers.filter((user) => user.id !== userId)
      );

      toast.error("Data Deleted Successfully!");
      navigate("/GalleryData");
    } catch (error) {
      console.error("There was an error!", error);
      toast.error("Failed to delete data!");
    }
  };

  return (
    <div className="container homeBanner-details">
      <div className="row arpi">
        <div className="col-lg-2 col-md-2 col-sm-12"></div>

        <div className="col-lg-10 col-md-10 col-sm-12 view-home">
          <Link to="/GalleryData-add">
            <button className="Banner-button">Add</button>
          </Link>
          <div className="row table-home">
            <table>
              <thead>
                <tr>
                  <th className="col-lg-1">Sr.No</th>
                  <th className="col-lg-2">Image</th>
                  <th className="col-lg-2">heading</th>
                  <th className="col-lg-1">Action</th>
                </tr>
              </thead>
              <tbody>
                {GalleryDataUser.map((user, index) => {
                  return (
                    <tr key={user.id}>
                      <td>{index + 1}</td>
                      <td>
                        {" "}
                        <img
                          src={user.gallerydataimage}
                          alt="GalleryData"
                          style={{ width: "150px", height: "100px" }}
                        />
                      </td>
                      <td>{user.heading}</td>
                      <td>
                        <Link to={`/GalleryData-view/` + user.id}>
                          <i
                            heading="View"
                            className="fa-regular fa-eye action-btn"
                            style={{ color: "blue" }}
                          ></i>
                        </Link>
                        <Link to={`/GalleryData-edit/` + user.id}>
                          <i className="fa-regular fa-pen-to-square action-btn"></i>
                        </Link>
                        <span onClick={() => deleteUser(user.id)}>
                          <i
                            heading="Delete"
                            className="fa-solid fa-trash-can action-btn"
                            style={{ color: "red" }}
                          ></i>
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export const GalleryDataAdd = () => {
  const [GalleryDataData, setGalleryDataData] = useState({
    heading: "",
    gallerydataimage: null,
  });

  const navigate = useNavigate();
const [previewImage, setPreviewImage] = useState("");

  const inputHandler = (e) => {
    const { name, value } = e.target;
    setGalleryDataData((prev) => ({ ...prev, [name]: value }));
  };

 const imageHandler = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      const maxSize = 2 * 1024 * 1024; // 2MB

      // Validate type
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }

      // Validate size
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }

      // Optional: Dimension check
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = () => {
        if (img.width > 1050 || img.height > 700) {
          toast.error("Image dimensions should not exceed 1350x700.");
          URL.revokeObjectURL(objectUrl);
          return;
        }

        setGalleryDataData((prev) => ({ ...prev, gallerydataimage: file }));
        setPreviewImage(objectUrl); 
      };
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (
      !GalleryDataData.heading ||
      !GalleryDataData.gallerydataimage
    ) {
      toast.error("All fields, including an image, are required!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("heading", GalleryDataData.heading);
      formData.append("gallerydataimage", GalleryDataData.gallerydataimage);

      await axios.post("https://admin.gosaviadvanceddentalclinic.com/api/createGalleryData", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Data added successfully!");
      navigate("/GalleryData"); // Redirect after success
    } catch (error) {
      console.error("Error adding GalleryData:", error);
      toast.error("Failed to add GalleryData!");
    }
  };

  return (
    <div className="container add-page">
      <div className="row">
        <div className="col-lg-2 col-md-2 col-sm-12" />
        <div className="col-lg-10 col-md-10 col-sm-12 add-details">
          <div className="add-banner">
            <Link to="/GalleryData">
              <i className="fa-solid fa-xmark"></i>
            </Link>
            <h3>Add Gallery Data</h3>
            <form
              className="row"
              onSubmit={submitForm}
              encType="multipart/form-data"
            >
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="heading">heading</label>
                <input
                  type="text"
                  onChange={inputHandler}
                  value={GalleryDataData.heading}
                  id="heading"
                  name="heading"
                  placeholder="Enter heading"
                />
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 inputform">
                <label htmlFor="gallerydataimage">Upload GalleryData Image</label>
                <input
                  type="file"
                  id="gallerydataimage"
                  name="gallerydataimage"
                  accept="image/*"
                  onChange={imageHandler}
                />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "70%",
                      height: "350px",
                      borderRadius: "8px",
                      display: "block",
                      margin: "10px auto"
                    }}
                  />
                )}
              </div>
              <div className="mobilesubmitform">
                <button type="submit">Add Data</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export const HomeGalleryDataEdit = () => {
    const [GalleryDatauser, setGalleryDataUser] = useState({
      heading: "",
      description: "",
      gallerydataimage: ""
    });
    const [previewImage, setPreviewImage] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();
  
 // Set preview image if already available
  useEffect(() => {
    if (
      GalleryDatauser.gallerydataimage &&
      typeof GalleryDatauser.gallerydataimage === "string"
    ) {
      setPreviewImage(GalleryDatauser.gallerydataimage);
    }
  }, [GalleryDatauser.gallerydataimage]);

  // Handle input change
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setGalleryDataUser({ ...GalleryDatauser, [name]: value });
  };

  // Handle image change
  const handleImageChange = (e) => {
    const file = e.target.files[0];
  
    if (file) {
      const allowedTypes = ["image/jpg", "image/jpeg", "image/png", "image/webp"];
      const maxSize = 2 * 1024 * 1024; // 2MB
  
      // ✅ Type check
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only JPG, JPEG, PNG, and WEBP files are allowed.");
        return;
      }
  
      // ✅ Size check
      if (file.size > maxSize) {
        toast.error("Image size should be under 2MB.");
        return;
      }
  
      // ✅ Optional: Dimension check (example: max 1920x1080)
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
  
      img.onload = () => {
        const { width, height } = img;
  
        // Example check (adjust if needed)
        if (width > 1050 || height > 700) {
          toast.error("Image dimensions should not exceed 1050x700.");
          URL.revokeObjectURL(objectUrl); // Clean up
          return;
        }
  
        setSelectedImage(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      };
    }
  };
  
    const fetchGalleryDataData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getoneGalleryData/${id}`
        );
        if (response.data.success) {
          setGalleryDataUser(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching GalleryData data!", error);
        toast.error("Failed to load GalleryData data.");
      }
    };
  
    useEffect(() => {
      fetchGalleryDataData();
    }, [id]);
  
    const submitForm = async (e) => {
        e.preventDefault();
    
        const formData = new FormData();
        formData.append("heading", GalleryDatauser.heading);
        if (selectedImage) {
          formData.append("gallerydataimage", selectedImage);
        }
    
        try {
          const response = await axios.put(
            `https://admin.gosaviadvanceddentalclinic.com/api/updateGalleryData/${id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
    
          if (response.data.success) {
            toast.success("Data updated successfully!");
            navigate("/GalleryData");
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          console.error("Error updating the gallerydata:", error);
          toast.error("Failed to update gallerydata.");
        }
      };
  
    return (
      <div
        className="modal fade show"
        id="update_heading"
        tabIndex={-1}
        style={{ display: "block", marginTop: 90, paddingBottom: 50 }}
        aria-modal="true"
      >
        <div className="modal-dialog">
          <form onSubmit={submitForm}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit</h5>
                <Link to="/GalleryData">
                  <button type="button" className="close">
                    <span aria-hidden="true">
                      <i className="fa-solid fa-xmark"></i>
                    </span>
                  </button>
                </Link>
              </div>
  
              <div className="modal-body">
                <div className="form-group">
                  <label>Heading</label>
                  <input
                    type="text"
                    value={GalleryDatauser.heading}
                    onChange={changeHandler}
                    className="form-control"
                    name="heading"
                    required
                  />
                  <br/>
                </div>

                <div className="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  name="galleryimage"
                  onChange={handleImageChange}
                  accept="image/*"
                />
                <br />
                {previewImage && (
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "100%",
                      height: "300px",
                    }}
                  />
                )}
              </div>
              </div>
  
              <div className="modal-footer">
                <Link to="/GalleryData">
                  <button type="button" className="btn btn-secondary">
                    Close
                  </button>
                </Link>
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };
export const HomeGalleryDataView = () => {
  const [GalleryDataUser, setGalleryDataUser] = useState({
    heading: "",
    gallerydataimage: "",
  });
  const { id } = useParams();

  useEffect(() => {
    const GalleryDataData = async () => {
      try {
        const response = await axios.get(
          `https://admin.gosaviadvanceddentalclinic.com/api/getoneGalleryData/${id}`
        );
        setGalleryDataUser(response.data.data);
      } catch (error) {
        console.error("There was an error!", error);
      }
    };
    GalleryDataData();
  }, [id]);

  return (
    <div className="container-fluid admin-view">
      <div className="row arpi">
        <div className="col-lg-3 col-md-3 col-sm-12"></div>

        <div className="col-lg-7 col-md-7 col-sm-12 view-sec">
          <Link to="/GalleryData" className="back-btn">
            <i className="fa-solid fa-arrow-left"></i> Back
          </Link>
          <br />
          <br />

          <h4>
            {GalleryDataUser.heading}{" "}
            <Link to={`/GalleryData-edit/` + GalleryDataUser.id}>
              <i className="fa-regular fa-pen-to-square"></i>
            </Link>
          </h4>
          <img
            src={GalleryDataUser.gallerydataimage}
            alt="GalleryData"
            style={{ width: "100%", height: "500px" }}
          />
        </div>
      </div>
    </div>
  );
};
